module.exports = __webpack_public_path__ + "static/em_capabilities_3_6-6c02ecea5180181afb1b1c0a17243aa8.png";